import { atom, getDefaultStore } from 'jotai';
import { TableDataState, TableFilters, TableState, TblStats, TblView } from '../../../core/table/table.types';
import { tableStatsVM, tableViewVM } from '../../../core/table/table_view_models';
import { PageState } from '../../../core/page/page.types';
import { MFRRestrictionsDataItem } from './mfr_restrictions_list_types';
import tableViewRepo from '../../../core/repo/viewStateRepo';
import { MFR_RESTRICTIONS_LIST_STORAGE_KEY } from '../mfr_restrictions_const';
import { pageStateVM } from '../../../core/page/page_view_models';
import { tableStateVM } from '../../../core/table/table_view_models';

export const pageStateAtom = atom<PageState>(pageStateVM());
export const tableStateAtom = atom<TableState>(tableStateVM());
export const tableViewAtom = atom<TblView>(tableViewVM());
export const tableFiltersAtom = atom<TableFilters>({});
export const tableStatsAtom = atom<TblStats>(tableStatsVM());
export const groupsDataAtom = atom<TableDataState<MFRRestrictionsDataItem>>({ items: [], dataItems: [] });

export function setAtomMFRRestrictionsListTableViewState(): void {
    // on Table exit save viewstate
    // note this can read the current Jotai values without subscribing (Jotai accessors)
    const defaultStore = getDefaultStore();
    const flt = defaultStore.get<TableFilters>(tableFiltersAtom);
    const stats = defaultStore.get<TblStats>(tableStatsAtom);
    const view = defaultStore.get<TblView>(tableViewAtom);
    tableViewRepo.setTable(MFR_RESTRICTIONS_LIST_STORAGE_KEY, flt, stats.paging, view.sort);
}
